'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSimilarPatients = updateSimilarPatients;
exports.default = initBundle;
var ispmImplDataHandler = require('./utils/dataHandlers/ispmDataHandler');
var updateHandler = require('./utils/updateHandler.js');
var configMenuHandler = require('./utils/configMenuHandler.js');
var _ = require('lodash');

function updateSimilarPatients(config, environment, data) {

  try {

    generateHTMLStructure(environment);
    //console.log(environment);

    //LogiPatientsJSON is injected by Logi on global level (see Index.html)
    if (environment === 'standAlone' || environment === 'logi') {
      if (!config) alert('No Config JSON available');
      if (!data) alert('No patients Data injected by Logi');

      if (environment === 'logi') {
        //Logi dls conversions
        $('input[type=checkbox]').ptCheckBox();
      }

      updateHandler.init(data, config, environment);
    } else if (environment === 'ISPM') {

      var hasData = _.size(data) > 0;
      var rootElement = ispmImplDataHandler.displayRootElement(hasData);

      if (hasData) {
        updateHandler.init(data, config, environment, rootElement);
      }
    }
  } catch (error) {
    console.error("error while updateSimilarPatients: " + JSON.stringify(error));
    return error;
  }
}

function generateHTMLStructure(environment) {

  // if HTML structure was already initialized - exit
  var cardSimilarPatientsElement = document.getElementById("card-similar-patients");
  if (cardSimilarPatientsElement) {
    return;
  }

  var container = document.getElementById("container-paralellplot");
  var cardSP = container.appendChild(createDiv('card-similar-patients', 'card-similar-patients', null));

  if (environment !== 'ISPM') {
    var menuIcon = createDiv('menu-icons-config', null, null);
    menuIcon.onclick = function (event) {
      configMenuHandler.onOpen();
    };
    container.appendChild(menuIcon);

    var iconMenu = document.createElement('i');
    iconMenu.className = 'iconfont-dls-24';
    iconMenu.innerHTML = '';
    menuIcon.append(iconMenu);

    var configMenu = container.appendChild(createDiv('menu-pp-config', 'config-menu', null));

    var navBar = configMenu.appendChild(createDiv('nav-bar', null, null));
    var navBarLeft = navBar.appendChild(createDiv('left', null, null));
    navBarLeft.appendChild(createDiv('header', null, 'Columns Configuration'));

    var navBarRight = navBar.appendChild(createDiv('right', null, null));

    var searchIcon = createDiv('search-icon', null, null);
    //searchIcon.onclick=function(event){ configMenuHandler.onOpen(); };
    navBarRight.appendChild(searchIcon);

    // let iconSearch=document.createElement('i');
    // iconSearch.className='iconfont-dls-16';
    // iconSearch.innerHTML = '';
    // searchIcon.append(iconSearch);

    var cTable = configMenu.appendChild(createDiv('table-container', null, null));
    var table = document.createElement('table');
    table.id = 'columns-table';
    table.className = 'table-fixed-header';
    cTable.appendChild(table);

    var bottomMenu = configMenu.appendChild(createDiv('bottom-menu', null, null));
    var menuRight = bottomMenu.appendChild(createDiv('right', null, null));

    var updateBtn = createDiv('btn-default', 'btn-apply', 'Apply');
    updateBtn.onclick = function (event) {
      configMenuHandler.onSave();
    };
    menuRight.appendChild(updateBtn);

    var closeBtn = createDiv('btn-quit', 'btn-cancel', 'Cancel');
    closeBtn.onclick = function (event) {
      configMenuHandler.onClose();
    };
    menuRight.appendChild(closeBtn);
  }

  var tt = container.appendChild(createDiv('tooltip', 'tooltip', null));

  var ttContent = tt.appendChild(createDiv('minimal', 'minimal', null));
  ttContent.appendChild(createDiv('top', 'pointer', null));
  ttContent.appendChild(createDiv('htmlContent', 'htmlContent', null));
}

var createDiv = function createDiv(className, id, innerHTML) {

  var div = document.createElement('div');
  div.className = className;
  if (id) div.id = id;
  if (innerHTML) div.innerHTML = innerHTML;
  return div;
};

function initBundle(patientsData, activePatient, config, environment) {

  if (activePatient) {
    var hash = Math.floor(Math.random() * 0x10000).toString(8);
    var id = -1;
    config.activePatient = { id: id };
    activePatient.patientID = id;
    patientsData = patientsData.concat(activePatient);
  };

  //dummy patient for Logi
  // let ap={};
  // _.each(activePatient, (value, key) =>{
  // 	if(key !== 'patientID') ap[key.toLowerCase()]=value;
  // })
  // console.log(ap);

  updateSimilarPatients(config, environment, patientsData);
};